module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/4/1-429d73fefef9beaacfe063eb5b483e0c.jpg";